function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 6.5a6.5 6.5 0 10-13 0 6.5 6.5 0 0013 0zm-1.08 0a5.42 5.42 0 10-10.84 0 5.42 5.42 0 0010.84 0zm-5.687.968A.532.532 0 015.957 7V3.51c0-.293.23-.53.515-.53.284 0 .514.237.514.53v3.226l2.338 1.03a.54.54 0 010 .748.506.506 0 01-.728 0l-2.358-1.04a.562.562 0 01-.005-.005z",
  fill: "currentColor"
});

var SvgClockSmall = function SvgClockSmall(props) {
  return React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='13' height='13' viewBox='0 0 13 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13 6.49996C13 2.91013 10.0898 0 6.5 0C2.91016 0 0 2.91013 0 6.49996C0 10.0898 2.91016 13 6.5 13C10.0898 13 13 10.0898 13 6.49996ZM11.9195 6.49996C11.9195 3.50691 9.49311 1.08055 6.5 1.08055C3.50689 1.08055 1.08052 3.50691 1.08052 6.49996C1.08052 9.49309 3.50689 11.9194 6.5 11.9194C9.49311 11.9194 11.9195 9.49309 11.9195 6.49996ZM6.23282 7.4683C6.06898 7.37973 5.95722 7.20287 5.95722 6.99918V3.50869C5.95722 3.21627 6.18756 2.97921 6.47167 2.97921C6.75578 2.97921 6.98612 3.21627 6.98612 3.50869V6.73537L9.32399 7.76518C9.52533 7.97197 9.52569 8.30691 9.32479 8.5132C9.1239 8.71953 8.79779 8.71917 8.59643 8.5124L6.2376 7.47328C6.236 7.47163 6.2344 7.46997 6.23282 7.4683Z' fill='currentColor' /%3E %3C/svg%3E";
export { SvgClockSmall as ReactComponent };